/**
 * DL-02 — what the web shell mounts once, next to its other hosts: the
 * download pill (bottom centre of the browser edge) and the "Downloads"
 * modal it opens. Renders nothing while no download is listed.
 */
import { useState, type ReactElement } from "react";
import { DownloadManagerDialog } from "./DownloadManagerDialog.js";
import { DownloadStatusBar } from "./DownloadStatusBar.js";

export interface DownloadManagerHostProps {
  /** how long the pill lingers after the last download finished or stopped; tests pass 0 */
  hideAfterMs?: number | undefined;
  /** DI-3-S48-FE — the pill sits in the shell's bottom dock (no own fixed position). */
  docked?: boolean | undefined;
}

export function DownloadManagerHost({
  hideAfterMs,
  docked,
}: DownloadManagerHostProps): ReactElement {
  const [open, setOpen] = useState(false);
  return (
    <>
      <DownloadStatusBar
        onOpen={() => {
          setOpen(true);
        }}
        hideAfterMs={hideAfterMs}
        docked={docked}
      />
      <DownloadManagerDialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}
